export default __webpack_public_path__ + "assets/images/776425e9357d044315ee159c0c753275.svg";